<div class="layout">
    <div class="layout-50 layout-left layout-flex">
        <app-sidebar-message></app-sidebar-message>
    </div>
    <div class="layout-50 layout-right layout-middle">
        <h1>{{ 'auth.login.heading' | translate }}</h1>

        <div class="narrow">
            <div class="alert alert-error" *ngIf="error">
                {{ 'auth.login.form.error' | translate }}
            </div>

            <app-auth-form #form [model]="model" [captcha]="captcha" (submit)="onFormSubmitted(form)"></app-auth-form>
        </div>
    </div>
</div>
